import CityPageTemplate from './CityPageTemplate';

const cityData = {
  cityName: "Lake Elmo",
  metaDescription: "Trusted plumber in Lake Elmo, MN. Bruce Nelson Plumbing & Heating offers expert plumbing and heating services for homes and businesses. Call 651-738-9354.",
  heroTitle: "Plumber in Lake Elmo, MN",
  heroSubtitle: "Expert plumbing services for Lake Elmo's rural and suburban homes.",
  introduction: "Lake Elmo homeowners choose Bruce Nelson Plumbing & Heating for reliable, professional plumbing services. Our team understands the unique needs of Lake Elmo properties, from estate homes to hobby farms. Whether you need well pump service, septic-related plumbing, or standard residential repairs, we've got you covered.",
  services: [
    {
      title: "Residential Plumbing",
      description: "Full plumbing services for Lake Elmo homes and properties.",
      link: "/services/residential"
    },
    {
      title: "Commercial Plumbing",
      description: "Professional plumbing for Lake Elmo's growing business community.",
      link: "/services/commercial"
    },
    {
      title: "Boiler Service",
      description: "Expert boiler services for Lake Elmo's larger homes.",
      link: "/services/boilers"
    },
    {
      title: "Water Heater Repair",
      description: "Reliable water heater service throughout Lake Elmo.",
      link: "/services/water-heaters"
    },
    {
      title: "Well Pump Service",
      description: "Well pump repair and installation for Lake Elmo properties.",
      link: "/services"
    },
    {
      title: "Remodeling Services",
      description: "Kitchen and bathroom remodeling for Lake Elmo homes.",
      link: "/services/remodeling"
    }
  ],
  whyChooseUs: [
    "Experience with Lake Elmo's unique property types",
    "Serving the area since 1976",
    "Licensed and insured Minnesota plumbers",
    "Well pump and rural plumbing expertise",
    "Fair, transparent pricing",
    "Prompt service to Lake Elmo and surroundings"
  ],
  serviceAreas: [
    { name: "Oakdale", link: "/plumber-oakdale" },
    { name: "Woodbury", link: "/plumber-woodbury" },
    { name: "Stillwater", link: "/plumber-saint-paul" },
    { name: "Maplewood", link: "/plumber-maplewood" },
    { name: "Saint Paul", link: "/plumber-saint-paul" },
    { name: "Cottage Grove", link: "/plumber-cottage-grove" }
  ],
  testimonial: {
    text: "BNPH handled our well pump issue perfectly. They're one of the few plumbers who really understand Lake Elmo properties. Excellent service!",
    author: "Robert M."
  }
};

const LakeElmoPage = () => <CityPageTemplate cityData={cityData} />;

export default LakeElmoPage;
